import { render } from "./AppAside.vue?vue&type=template&id=3cbbaa86&ts=true"
import script from "./AppAside.vue?vue&type=script&lang=ts"
export * from "./AppAside.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__